const DecimalNumber = {
  print: ({ node }) => node.value
};

module.exports = DecimalNumber;
